import AppRouteInfo from '../../../../routers/AppRouter/info';
import { getRouteMatch } from './getRouteMatch';

export function getAppRouteData(url) {
    const match = getRouteMatch(url);

    // If not matched
    if (!match)
        return undefined;

    // Finding route and get the permission key from route
    // NOTE: Only appRoutes has permission settings (not storeRoutes or publicRoutes)
    return AppRouteInfo.find(route => route.path === match.path);
}
